document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  /* =========================================================
     HEADER
  ========================================================= */

  const header = document.querySelector('[data-header]');

  const updateHeader = () => {
    if (!header) return;

    header.classList.toggle('is-scrolled', window.scrollY > 24);
  };

  updateHeader();

  window.addEventListener('scroll', updateHeader, {
    passive: true
  });

  /* =========================================================
     MOBILE MENU
  ========================================================= */

  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = mobileMenu.classList.toggle('is-open');

      menuToggle.setAttribute('aria-expanded', String(isOpen));
      menuToggle.textContent = isOpen ? 'CLOSE' : 'MENU';

      document.body.classList.toggle('menu-is-open', isOpen);
    });

    mobileMenu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        mobileMenu.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
        menuToggle.textContent = 'MENU';
        document.body.classList.remove('menu-is-open');
      });
    });
  }

  /* =========================================================
     SCROLL REVEALS
  ========================================================= */

  const revealElements = document.querySelectorAll('.reveal');

  const revealImmediately = () => {
    revealElements.forEach((element) => {
      element.classList.add('is-visible');
    });
  };

  if (!('IntersectionObserver' in window) || reducedMotion) {
    revealImmediately();
  } else {
    const revealObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.16,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    revealElements.forEach((element) => {
      revealObserver.observe(element);
    });
  }

  /* =========================================================
     GENERAL SCROLL HELPERS
  ========================================================= */

  const normalScroll = (target) => {
    if (!target) return;

    target.scrollIntoView({
      behavior: reducedMotion ? 'auto' : 'smooth',
      block: 'start'
    });
  };

  const jumpToTarget = (target) => {
    if (!target) return;

    target.scrollIntoView({
      behavior: 'auto',
      block: 'start'
    });
  };

  /* =========================================================
     HERO — ENTER THE DEN
  ========================================================= */

  const doorTransition = document.querySelector(
    '[data-door-transition]'
  );

  const enterLinks = document.querySelectorAll('[data-enter-den]');

  const runDoorTransition = (target) => {
    if (!doorTransition || reducedMotion) {
      normalScroll(target);
      return;
    }

    document.body.classList.add('is-transitioning');

    doorTransition.classList.remove('is-opening');
    doorTransition.classList.add('is-closing');

    window.setTimeout(() => {
      jumpToTarget(target);

      doorTransition.classList.remove('is-closing');
      doorTransition.classList.add('is-opening');

      window.setTimeout(() => {
        doorTransition.classList.remove('is-opening');
        document.body.classList.remove('is-transitioning');
      }, 1000);
    }, 1000);
  };

  enterLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      const selector = link.getAttribute('href');

      if (!selector || !selector.startsWith('#')) return;

      const target = document.querySelector(selector);

      if (!target) return;

      event.preventDefault();
      runDoorTransition(target);
    });
  });

  /* =========================================================
     MALL STOREFRONT INTERACTIONS
  ========================================================= */

  const storefronts = document.querySelectorAll('[data-storefront]');
  const storeEntryLinks = document.querySelectorAll(
    '[data-store-entry]'
  );

  const storeTransition = document.querySelector(
    '.gs-store-entry-transition'
  );

  const storeTransitionName = document.querySelector(
    '[data-store-transition-name]'
  );

  let storeTransitionRunning = false;

  const clearStorefrontStates = () => {
    storefronts.forEach((storefront) => {
      storefront.classList.remove('is-hovered');
      storefront.classList.remove('is-entering');
    });
  };

  storefronts.forEach((storefront) => {
    const link = storefront.querySelector('[data-store-entry]');

    storefront.addEventListener('mouseenter', () => {
      if (storeTransitionRunning) return;

      storefronts.forEach((item) => {
        item.classList.toggle('is-hovered', item === storefront);
      });
    });

    storefront.addEventListener('mouseleave', () => {
      if (storeTransitionRunning) return;

      storefront.classList.remove('is-hovered');
    });

    storefront.addEventListener('focusin', () => {
      storefronts.forEach((item) => {
        item.classList.toggle('is-hovered', item === storefront);
      });
    });

    storefront.addEventListener('focusout', (event) => {
      if (storefront.contains(event.relatedTarget)) return;

      storefront.classList.remove('is-hovered');
    });

    if (!link) return;

    link.addEventListener('touchstart', () => {
      if (storeTransitionRunning) return;

      storefronts.forEach((item) => {
        item.classList.toggle('is-hovered', item === storefront);
      });
    }, {
      passive: true
    });
  });

  const completeStoreNavigation = (href) => {
   if (href.startsWith('#')) {
  let target = null;

  try {
    target = document.querySelector(href);
  } catch (error) {
    target = null;
  }

  if (target) {
    jumpToTarget(target);
  }

  window.setTimeout(() => {
    if (storeTransition) {
      storeTransition.classList.remove('is-active');
    }

    document.body.classList.remove('is-store-transitioning');
    clearStorefrontStates();
    storeTransitionRunning = false;
  }, target ? 450 : 150);

  return;
}

    window.location.href = href;
  };

  const runStoreEntryTransition = (link) => {
    if (storeTransitionRunning) return;

    const href = link.getAttribute('href');
    const storeName =
      link.dataset.storeName ||
      link.closest('[data-storefront]')
        ?.querySelector('.gs-storefront__title')
        ?.textContent
        ?.trim() ||
      'THE STORE';

    const storefront = link.closest('[data-storefront]');

    if (reducedMotion || !storeTransition) {
      completeStoreNavigation(href);
      return;
    }

    storeTransitionRunning = true;

    clearStorefrontStates();

    if (storefront) {
      storefront.classList.add('is-hovered');
      storefront.classList.add('is-entering');
    }

    if (storeTransitionName) {
      storeTransitionName.textContent = storeName;
    }

    document.body.classList.add('is-store-transitioning');

    window.setTimeout(() => {
      storeTransition.classList.add('is-active');
    }, 220);

    window.setTimeout(() => {
      completeStoreNavigation(href);
    }, 1650);
  };

  storeEntryLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      if (
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      const href = link.getAttribute('href');

      if (!href || href === '#') {
        event.preventDefault();
        return;
      }

      event.preventDefault();
      runStoreEntryTransition(link);
    });
  });

  /* =========================================================
     STANDARD INTERNAL ANCHOR LINKS
  ========================================================= */

  document
    .querySelectorAll(
      'a[href^="#"]:not([data-enter-den]):not([data-store-entry])'
    )
    .forEach((link) => {
      link.addEventListener('click', (event) => {
        const selector = link.getAttribute('href');

        if (!selector || selector === '#') return;

        let target;

        try {
          target = document.querySelector(selector);
        } catch (error) {
          return;
        }

        if (!target) return;

        event.preventDefault();
        normalScroll(target);
      });
    });

  /* =========================================================
     RESET TRANSITION AFTER BROWSER BACK
  ========================================================= */

  window.addEventListener('pageshow', () => {
    storeTransitionRunning = false;

    document.body.classList.remove(
      'is-transitioning',
      'is-store-transitioning'
    );

    if (doorTransition) {
      doorTransition.classList.remove(
        'is-opening',
        'is-closing'
      );
    }

    if (storeTransition) {
      storeTransition.classList.remove('is-active');
    }

    clearStorefrontStates();
  });
});